<div fxLayout="column" fxLayoutAlign="start stretch" class="outerwrap">
    <h1 mat-dialog-title>{{title}}</h1>
    <div class="scroll" fxFlex fxLayout="column" fxLayoutAlign="start stretch">
        <div [innerHTML]="message | safeHTML"></div>
        <mat-table class="bordered" #table [dataSource]="CourseData">
            <ng-container matColumnDef="Course">
                <mat-header-cell *matHeaderCellDef class="centered">Course</mat-header-cell>
                <mat-cell *matCellDef="let course" class="centered">{{course.FullCode}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Name">
                <mat-header-cell *matHeaderCellDef class="centered">Name</mat-header-cell>
                <mat-cell *matCellDef="let course" class="centered">{{course.Name}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="ReferenceNum">
                <mat-header-cell *matHeaderCellDef class="centered">Reference #</mat-header-cell>
                <mat-cell *matCellDef="let course" class="centered">
                    <mat-form-field floatPlaceholder="never">
                        <input matInput type="text" [(ngModel)]="course.ReferenceNumber" maxlength="15" placeholder="Enter Ref. #" (keyup)="CheckForChanges()" />
                    </mat-form-field>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="CountyTaught">
                <mat-header-cell *matHeaderCellDef class="centered">Taught At PCPS</mat-header-cell>
                <mat-cell *matCellDef="let course" class="mat-checkbox centered">
                    <mat-checkbox [(ngModel)]="course.CountyTaught" (change)="CheckForChanges()"></mat-checkbox>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="SmallDisplay">
                <mat-header-cell *matHeaderCellDef class="centered">Request(s)</mat-header-cell>
                <mat-cell *matCellDef="let course">
                    <div fxLayout="column" fxLayoutAlign="start stretch">
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <form-label>Course</form-label>
                            <div fxFlex="70">{{course.FullCode}}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <form-label>Name</form-label>
                            <div fxFlex="70">{{course.Name}}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between start">
                            <form-label>Ref #</form-label>
                            <mat-form-field floatLabel="never" fxFlex="70">
                                <input matInput type="text" [(ngModel)]="course.ReferenceNumber" maxlength="15" placeholder="Enter Ref. #" (keyup)="CheckForChanges()" />
                            </mat-form-field>
                        </div>
                        <mat-checkbox class="bottompad" [(ngModel)]="course.CountyTaught" (change)="CheckForChanges()"><form-label>Taught At PCPS</form-label></mat-checkbox>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
            <mat-row *matRowDef="let row;columns:VisibleColumns"></mat-row>
        </mat-table>
        <mat-paginator #paginator [length]="CourseData.data.length" [pageIndex]="0" [pageSize]="5" [pageSizeOptions]="[5, 10, 25]"></mat-paginator>
    </div>
    <div class="actionbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
        <button mat-raised-button color="warn" (click)="CancelHandler()"><span [innerHTML]="canceltext | safeHTML"></span></button>
        <button mat-raised-button color="primary" (click)="OkHandler()" [disabled]="!ReadyStatus.Ready"><span [innerHTML]="oktext | safeHTML"></span></button>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/services/dialogs/fullschedule/fullschedule.dialogcomponent.html